/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AgentResourcePairing } from './agentResourcePairing';
import { Issues } from './issues';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';
import { AgentResource } from './agentResource';


export interface AgentPairingValidationResponse { 
    /**
     * Agent ID
     */
    agent_id?: string;
    /**
     * Agent Version
     */
    agent_version?: string;
    /**
     * Agent display name
     */
    agent_display_name?: string;
    service_type?: ServiceTypeEnum;
    vcds_service_type?: VcdsServiceTypeEnum;
    existing_agent_pairing?: AgentResourcePairing;
    existing_resource_pairings?: Array<AgentResourcePairing>;
    /**
     * Seconds after which pairing codes will expire
     */
    expires_in?: number;
    issues?: Issues;
    resource?: AgentResource;
}
export namespace AgentPairingValidationResponse {
}


